module.exports = __webpack_public_path__ + "static/media/photo143.178acdf7.jpg";